/* eslint-disable jsx-a11y/accessible-emoji */
import React, { Suspense, useState, useRef } from "react";
import { unstable_scheduleCallback } from "scheduler";
import { unstable_createResource as createResource } from "react-cache";
import {
  Combobox,
  ComboboxInput,
  ComboboxList,
  ComboboxOption,
  ComboboxOptionText
} from "./Combobox2.js";
import { useThrottle } from "use-throttle";
import uniqBy from "lodash.uniqby";

function App({ tabIndex, navigate }) {
  let [searchTerm, setSearchTerm] = useState(null);
  let throttledSearchTerm = useThrottle(searchTerm, 100);
  let [selection, setSelection] = useState(null);
  let [searchTerm2, setSearchTerm2] = useState(null);

  return (
    <div style={{ maxWidth: 600, margin: "auto" }}>
      <h1 style={{ textAlign: "center" }}>Combobox</h1>
      <h2>iTunes Search</h2>
      <p>
        last selection: <i>{selection}</i>
      </p>
      <form
        onSubmit={event => {
          event.preventDefault();
        }}
      >
        <Combobox onSelect={setSelection}>
          <ComboboxInput
            selectOnClick={true}
            onChange={event => {
              let value = event.target.value;
              unstable_scheduleCallback(() => {
                setSearchTerm(value);
              });
            }}
          />
          <Suspense maxDuration={5000} fallback={<div>Loading...</div>}>
            <AsyncList
              searchTerm={
                searchTerm && searchTerm.length < 3 ? null : searchTerm
              }
            />
          </Suspense>
        </Combobox>
      </form>

      <div style={{ height: 50 }} />

      <h2>Client side search</h2>
      <Combobox>
        <ComboboxInput onChange={event => setSearchTerm2(event.target.value)} />
        <ComboboxList ariaText={`10 Results for ${searchTerm2}`}>
          {searchTerm2 && searchTerm2.trim() !== ""
            ? Array.from({ length: 10 }).map((_, index) => (
                <ComboboxOption
                  key={index}
                  value={`${searchTerm2} ${rando()}`}
                />
              ))
            : null}
        </ComboboxList>
      </Combobox>

      <div style={{ height: 50 }} />

      <h2>Custom rendering</h2>
      <p>(options intentionally static)</p>
      <Combobox>
        <ComboboxInput />
        <ComboboxList ariaText="10 Results">
          <ComboboxOption value="Apple">
            🍎 <ComboboxOptionText />
          </ComboboxOption>
          <ComboboxOption value="Banana">
            🍌 <ComboboxOptionText />
          </ComboboxOption>
          <ComboboxOption value="Orange">
            🍊 <ComboboxOptionText />
          </ComboboxOption>
          <ComboboxOption value="Pineapple">
            🍍 <ComboboxOptionText />
          </ComboboxOption>
          <ComboboxOption value="Kiwi">
            🥝 <ComboboxOptionText />
          </ComboboxOption>
        </ComboboxList>
      </Combobox>

      <div style={{ height: 400 }} />
    </div>
  );
}

let ImageResource = createResource(src => {
  return new Promise(resolve => {
    let img = new Image();
    img.src = src;
    img.onload = () => {
      resolve(src);
    };
  });
});

function Img({ src, ...props }) {
  // eslint-disable-next-line jsx-a11y/alt-text
  return <img src={ImageResource.read(src)} {...props} />;
}

function AsyncList({ searchTerm }) {
  if (!searchTerm) return null;

  let songs = ITunesResource.read(searchTerm);

  return songs ? (
    <ComboboxList ariaText={`${songs.length} results`}>
      {songs.map(song => (
        <ComboboxOption
          key={song.trackId}
          value={`${song.trackName}, ${song.collectionName}`}
          style={{
            display: "flex",
            alignItems: "center"
          }}
        >
          <Suspense
            maxDuration={500}
            fallback={
              <span style={{ width: 30, height: 30, background: "#eee" }} />
            }
          >
            <span style={{ width: 30, height: 30, textAlign: "center" }}>
              <Img
                alt={song.collectionName}
                src={song.artworkUrl60}
                height="30"
              />
            </span>
          </Suspense>
          <span style={{ marginLeft: 10 }}>
            <ComboboxOptionText />
          </span>
        </ComboboxOption>
      ))}
    </ComboboxList>
  ) : null;
}

let rando = () =>
  Math.random()
    .toString(16)
    .substr(2, 6);

let ITunesResource = createResource(async value => {
  try {
    let res = await fetch(`https://itunes.now.sh/?term=${value}`);
    let json = await res.json();
    let songs = json.results.filter(song => song.trackName);
    let unique = uniqBy(
      songs,
      song => `${song.trackName}, ${song.collectionName}`
    );
    return unique.slice(0, 10);
  } catch (e) {
    return Promise.resolve(null);
  }
});

export default () => (
  <Suspense maxDuration={5000} fallback={<div>Loading...</div>}>
    <App />
  </Suspense>
);



// WEBPACK FOOTER //
// ./src/App.Combobox.js